import { yupResolver } from "@hookform/resolvers/yup";
import { useDatabase } from "@nozbe/watermelondb/hooks";
import { useNavigation } from "@react-navigation/native";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import {
  Form,
  Page,
  Text,
  Button,
  Card,
} from "@towersystems/roam-common-native";
import { useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { Colors, Spacings, View } from "react-native-ui-lib";
import { CustomerRootParamList } from "../../../../types";
import Customer from "../../../../utilities/data/model/Customer";
import { CustomerDetailsForm } from "../../components/CustomerDetailsForm";
import {
  createCustomerInputSchema,
  CustomerFormValues,
  defaultCustomerInputValues,
  useMutationCreateCustomer,
} from "../../utils/customer";
import { useSaleControllerProvider } from "../../utils/sale-controller";
import { useCustomerRootScreenActionsContextProvider } from "../CustomerRootScreen/hooks";

export type CustomerListScreenProps = NativeStackScreenProps<
  CustomerRootParamList,
  "CreateCustomerScreen"
>;

export function CreateCustomerScreen() {
  const maybeContext = useCustomerRootScreenActionsContextProvider();
  const navigation = useNavigation();
  const { sale } = useSaleControllerProvider();
  const database = useDatabase();

  const methods = useForm<CustomerFormValues>({
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: defaultCustomerInputValues,
    resolver: yupResolver(createCustomerInputSchema),
  });

  const {
    formState: { isValid },
  } = methods;

  const { createCustomer } = useMutationCreateCustomer();

  async function onValidSubmit(formValues: any) {
    createCustomer(formValues).then(async (customer) => {
      const localCustomer = await database.write(async () => {
        return await database
          .get<Customer>("customers")
          .create((customerLocal) => {
            customerLocal._raw.id = customer.id;
            customerLocal.firstName = customer.firstName;
            customerLocal.lastName = customer.lastName;
            customerLocal.emailAddress = customer.emailAddress || null;
            customerLocal.mobileNumber = customer.mobileNumber || null;
            customerLocal.phoneNumber = customer.phoneNumber || null;
            customerLocal.createdAt = customer.createdAt;
            customerLocal.updatedAt = customer.updatedAt;
          });
      });

      if (maybeContext?.onAfterCreateCustomer) {
        await maybeContext.onAfterCreateCustomer(localCustomer.id);
        return;
      }

      return sale
        ?.addCustomer(localCustomer.id)
        .then(() => navigation.navigate("SellScreen" as any))
        .catch((err) => console.log(err));
    });
  }
  const footerMarkup = (
    <Button
      backgroundColor={Colors.action}
      color="white"
      disabled={!isValid}
      label="Create Customer"
      onPress={methods.handleSubmit(onValidSubmit, console.log)}
    />
  );

  return (
    <Page
      title="New Customer"
      secondaryTitle="Create a new customer to add to the sale"
      footer={footerMarkup}
    >
      <FormProvider {...methods}>
        <Form>
          <Card title={"Customer Details"}>
            <CustomerDetailsForm />
          </Card>
        </Form>
      </FormProvider>
    </Page>
  );
}
